import * as R from 'ramda';
import angular from 'angular';

class bcpUtilityService {
  constructor() {
    console.log('app.services.bcpUtilityService created');
  }

  /**
   * Takes in BCP user team data in the /bcp/assessment/${assessmentId}/teamMember/byUser route call and transforms it
   * to match the expected view model
   * @param {object} JSON object of data including the user and his/her BCP team affiliation in a weird format
   * @returns {JSON} Simplified JSON object containing the same data
   */
  transformInternalUsersData(rawUserTeamData) {
    return R.map(
      userTeamItem => R.merge(
        userTeamItem.user,
        {
          onInitialResponseTeam: userTeamItem.isInitialResponseTeam,
          onCrisisManagementTeam: userTeamItem.isCrisisManagementTeam,
          onDepartmentalRecoveryTeam: userTeamItem.isDepartmentalRecoveryTeam,
        }
      ),
      rawUserTeamData
    );
  }

  /**
   * Takes in BCP user data from editAuthorityAndManagementDialog's view model and transforms it to match the expected
   * DTO for the save
   * @param {string} fileName File name to convert
   * @returns {string} 3 letter file extension
   */
  transformInternalContactsForSave(internalContacts) {
    return R.map((internalContact) => {
      internalContact.isInitialResponseTeam = internalContact.onInitialResponseTeam;
      internalContact.isCrisisManagementTeam = internalContact.onCrisisManagementTeam;
      internalContact.isDepartmentalRecoveryTeam = internalContact.onDepartmentalRecoveryTeam;
      return internalContact;
    }, internalContacts);
  }
}

bcpUtilityService.$inject = [];

export default angular.module('app.services.bcpUtilityService', [])
  .service('bcpUtilityService', bcpUtilityService)
  .name;
